function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.0136 2.99869C11.4171 2.18112 12.5829 2.18112 12.9864 2.99869L15.2708 7.62732C15.431 7.95198 15.7407 8.177 16.099 8.22906L21.207 8.9713C22.1092 9.1024 22.4695 10.2112 21.8166 10.8476L18.1205 14.4504C17.8612 14.7032 17.7429 15.0673 17.8041 15.4241L18.6766 20.5114C18.8308 21.41 17.8876 22.0953 17.0806 21.671L12.5119 19.2691C12.1914 19.1006 11.8086 19.1006 11.4881 19.2691L6.91939 21.671C6.1124 22.0953 5.16923 21.41 5.32335 20.5114L6.1959 15.4241C6.2571 15.0673 6.1388 14.7032 5.87954 14.4504L2.18337 10.8476C1.5305 10.2112 1.89076 9.1024 2.793 8.9713L7.90099 8.22906C8.25927 8.177 8.569 7.95198 8.72922 7.62732L11.0136 2.99869Z"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.feddf612.svg";
export { ForwardRef as ReactComponent };